import client from "@irati/utils/services/apollo"
import AuthStorage from "@irati/auth/streams/auth/storage"
import AuthServiceAbstract from "@irati/auth/streams/auth/base"
import tokens from "@irati/auth/services/tokens"
import InternalAuth from "../../types/InternalAuth"
import resumeInternalQuery from "../../services/queries/resumeInternal"

class InternalAuthStream extends AuthServiceAbstract<InternalAuth> {
  private _hasRequestTokens = false

  start(data: InternalAuth) {
    return super.start(data)
  }

  isValid(auth: InternalAuth) {
    return !!auth.user
  }

  async init() {
    const data = await this.storage.get()
    if (!this._hasRequestTokens) {
      this._hasRequestTokens = true
      await tokens.resume()
    }

    return this.start(data)
  }

  protected query(data: InternalAuth) {
    const variables = {email: data.user.email}
    return async () => client.watchQuery<InternalAuth>({query: resumeInternalQuery, variables, fetchPolicy: "network-only"})
  }
}

export default new InternalAuthStream({storage: new AuthStorage("internal")})
